import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/assets/eye-icon.svg'
import _imports_1 from '@/assets/phase-menu-calendar-icon.svg'
import _imports_2 from '@/assets/caret_up.svg'


const _hoisted_1 = {
  key: 0,
  class: "w-[220px] h-full overflow-y-auto flex flex-col bg-[#E5E4E2]"
}
const _hoisted_2 = { class: "text-base leading-[26px] tracking-[0.01rem] uppercase font-medium text-[#51687A]" }
const _hoisted_3 = { class: "w-full flex flex-col items-start mt-2" }
const _hoisted_4 = { class: "w-full flex flex-wrap items-center gap-1" }
const _hoisted_5 = { class: "text-[#393840] font-medium text-sm tracking-[0.01rem]" }
const _hoisted_6 = { class: "flex items-center" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "w-full flex items-center gap-1" }
const _hoisted_9 = { class: "text-[#393840] font-medium text-sm tracking-[0.01rem]" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = {
  key: 1,
  class: "w-[220px] h-full flex flex-col overflow-y-auto"
}
const _hoisted_12 = { class: "text-base leading-[26px] tracking-[0.01rem] uppercase font-medium text-[#51687A]" }
const _hoisted_13 = { class: "w-full flex flex-col items-start mt-2 h-fit" }
const _hoisted_14 = { class: "w-fit flex items-center flex-wrap gap-[2px] p-[6px] rounded-primary-radius hover:bg-[#D3D1CD] duration-300" }
const _hoisted_15 = {
  key: 0,
  src: _imports_2,
  alt: "Eye"
}
const _hoisted_16 = {
  key: 1,
  src: _imports_0,
  alt: ""
}
const _hoisted_17 = { class: "text-[#393840] font-medium text-sm tracking-[0.01rem] pr-1" }
const _hoisted_18 = { class: "flex items-center" }
const _hoisted_19 = {
  key: 0,
  class: "w-full h-fit"
}
const _hoisted_20 = {
  key: 0,
  class: "w-full flex items-center justify-center my-4"
}
const _hoisted_21 = {
  key: 1,
  class: "pl-5 h-fit"
}
const _hoisted_22 = { class: "w-full cursor-pointer" }
const _hoisted_23 = ["onClick"]
const _hoisted_24 = {
  key: 0,
  src: _imports_2,
  alt: "Caret"
}
const _hoisted_25 = {
  key: 1,
  src: _imports_1,
  alt: "Calendar"
}
const _hoisted_26 = { class: "text-[#393840] font-medium text-sm tracking-[0.01rem]" }
const _hoisted_27 = {
  key: 0,
  class: "pl-5"
}
const _hoisted_28 = {
  key: 2,
  class: "w-[220px] h-full overflow-y-auto flex flex-col"
}
const _hoisted_29 = { class: "flex text-base leading-[26px] tracking-[0.01rem] uppercase font-medium text-[#51687A]" }
const _hoisted_30 = { class: "w-full flex flex-col items-start mt-2" }
const _hoisted_31 = { class: "w-full flex flex-wrap items-center gap-[2px] p-[6px] rounded-primary-radius hover:bg-[#D3D1CD] duration-300" }
const _hoisted_32 = { class: "text-[#393840] font-medium text-sm tracking-[0.01rem] pr-1" }
const _hoisted_33 = { class: "flex items-center" }
const _hoisted_34 = { class: "w-full cursor-pointer" }
const _hoisted_35 = ["onClick"]
const _hoisted_36 = {
  key: 0,
  src: _imports_2,
  alt: "Caret"
}
const _hoisted_37 = {
  key: 1,
  src: _imports_1,
  alt: "Calendar"
}
const _hoisted_38 = { class: "text-[#393840] font-medium text-[14px] tracking-[0.01rem]" }
const _hoisted_39 = {
  key: 0,
  class: "mt-1"
}
const _hoisted_40 = {
  key: 0,
  class: "w-full flex items-center justify-center my-4"
}
const _hoisted_41 = {
  key: 1,
  class: "pl-5"
}

import SpinnerLoader from "@/components/Loaders/SpinnerLoader.vue";
import { getPhaseStatusColor } from "@/utils/status-color";
import { ref, watch } from "vue";
import { useRoute } from "vue-router";
import ColoredDot from "@/components/Re-usable/ColoredDot.vue";
import { useTranslate } from "@/composables/useTranslate";

type Props = {
  projectDetails?: any | null;
  phasePage?: any | null;
  appointmentPage?: any | null;
  isLoading?: boolean;
};

export default /*@__PURE__*/_defineComponent({
  __name: 'PhaseSidemenu',
  props: {
    projectDetails: {},
    phasePage: {},
    appointmentPage: {},
    isLoading: { type: Boolean }
  },
  setup(__props: any) {

const route = useRoute();
const projectId = route.params.id;

const props = __props;

const isAppointmentDropdown = ref(false);
const selectedAppointment = ref();

const isPhaseStepsDropdown = ref(false);
const selectedPhaseId = ref<number | null>(null);
const { t } = useTranslate();
const appointmentsDropdownOpened = ref([]);

// const isAppointmentItemActive = ref(false);

const toggleAppointmentsDropdown = (phase: any) => {
  if (appointmentsDropdownOpened.value.includes(phase)) {
    appointmentsDropdownOpened.value = appointmentsDropdownOpened.value.filter(
      (item: any) => item !== phase
    );
  } else {
    appointmentsDropdownOpened.value.push(phase);
  }

  if (selectedAppointment.value === phase) {
    isAppointmentDropdown.value = !isAppointmentDropdown.value;

    if (!isAppointmentDropdown.value) {
      selectedAppointment.value = null;
    }
  } else {
    selectedAppointment.value = phase;
    isAppointmentDropdown.value = true;
  }
};

watch(
  () => [route.params.phaseId, route.params.terminId],
  ([newPhaseId, newTerminId]) => {
    if (newPhaseId && props.phasePage?.phases) {
      const matchedPhase = props.phasePage.phases.find(
        (phase: any) => String(phase.phaseId) === String(newPhaseId)
      );
      if (matchedPhase) {
        selectedPhaseId.value = matchedPhase.phaseId;
        isPhaseStepsDropdown.value = true;
        if (!appointmentsDropdownOpened.value.includes(matchedPhase.phaseId)) {
          appointmentsDropdownOpened.value.push(matchedPhase.phaseId);
        }
      }
    } else {
      selectedPhaseId.value = null;
      isPhaseStepsDropdown.value = false;
    }

    if (newTerminId && props.appointmentPage) {
      for (const phase of props.appointmentPage) {
        const matchedTermin = phase.termins.find(
          (termin: any) => String(termin.id) === String(newTerminId)
        );
        if (matchedTermin) {
          if (!newPhaseId) {
            selectedPhaseId.value = phase.phase.id;
          }

          selectedAppointment.value = newTerminId;
          isAppointmentDropdown.value = true;
          if (
            !appointmentsDropdownOpened.value.includes(selectedPhaseId.value)
          ) {
            appointmentsDropdownOpened.value.push(selectedPhaseId.value);
          }
          break;
        }
      }
    } else {
      selectedAppointment.value = null;
      isAppointmentDropdown.value = false;
      appointmentsDropdownOpened.value =
        appointmentsDropdownOpened.value.filter(
          (item: any) => item !== newPhaseId
        );
    }
  },
  { immediate: true }
);

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (props.projectDetails)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.projectDetails, (phase, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: phase.phaseId,
            class: _normalizeClass(["w-full h-fit rounded-[4px] m-[2px] mt-[1px] ml-[1px] py-4 px-3 bg-[#E5E4E2]", index === props.projectDetails.length - 1 ? 'h-full' : 'h-auto'])
          }, [
            _createElementVNode("h4", _hoisted_2, _toDisplayString(phase?.phase), 1),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_RouterLink, {
                to: `/projects/${_unref(projectId)}/phase/${phase.phaseId}`,
                class: "w-fit cursor-pointer p-[6px] rounded-primary-radius hover:bg-[#D3D1CD] duration-300"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_4, [
                    _cache[0] || (_cache[0] = _createElementVNode("img", {
                      src: _imports_0,
                      alt: "Eye"
                    }, null, -1)),
                    _createElementVNode("h5", _hoisted_5, _toDisplayString(_unref(t)("global.review")), 1),
                    _createElementVNode("div", _hoisted_6, [
                      ([3, 4, 5].includes(phase.phaseStatus?.id))
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 0,
                            class: "text-primary-text-color font-medium text-[13px] tracking-[0.01rem] px-[5px] py-[2px] rounded-primary-radius",
                            style: _normalizeStyle({
                  backgroundColor: `${_unref(getPhaseStatusColor)(
                    phase.phaseStatus?.id
                  )}`,
                })
                          }, _toDisplayString(phase.phaseStatus.name), 5))
                        : (_openBlock(), _createBlock(ColoredDot, {
                            key: 1,
                            "status-name": phase.phaseStatus.name,
                            "status-id": phase.phaseStatus.id,
                            "is-termin": false
                          }, null, 8, ["status-name", "status-id"]))
                    ])
                  ])
                ]),
                _: 2
              }, 1032, ["to"]),
              _createElementVNode("div", {
                onClick: ($event: any) => (toggleAppointmentsDropdown(phase)),
                class: "w-full cursor-pointer p-[6px] rounded-primary-radius hover:bg-[#D3D1CD] duration-300"
              }, [
                _createElementVNode("div", _hoisted_8, [
                  _cache[1] || (_cache[1] = _createElementVNode("img", {
                    src: _imports_1,
                    alt: "Calendar"
                  }, null, -1)),
                  _createElementVNode("h5", _hoisted_9, _toDisplayString(_unref(t)("global.termins")), 1)
                ])
              ], 8, _hoisted_7),
              (selectedAppointment.value === phase)
                ? (_openBlock(), _createElementBlock("ul", _hoisted_10, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(phase.termins, (termin) => {
                      return (_openBlock(), _createElementBlock("li", {
                        class: "w-full flex flex-col gap-2 mb-[2px] pl-5 relative before:absolute before:w-[2px] before:bg-[#D3D1CD] before:h-full before:-ml-[6px]",
                        key: termin.id
                      }, [
                        _createVNode(_component_RouterLink, {
                          to: `/projects/${_unref(route).params.id}/termin/${termin.id}`,
                          class: "w-full flex items-center gap-[6px] text-sm p-[6px] rounded-primary-radius bg-transparent text-primary-text-color font-medium tracking-[0.01rem] cursor-pointer hover:bg-white duration-300"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", null, _toDisplayString(termin.end
                  ? new Date(termin.end).toLocaleDateString("DE")
                  : "Not scheduled"), 1),
                            _createVNode(ColoredDot, {
                              "status-name": termin.status.name,
                              "status-id": termin.status.id,
                              "is-termin": true
                            }, null, 8, ["status-name", "status-id"])
                          ]),
                          _: 2
                        }, 1032, ["to"])
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ])
          ], 2))
        }), 128))
      ]))
    : (props.phasePage)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.phasePage?.phases, (phase, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: phase.phaseId,
              class: _normalizeClass(["w-full h-fit rounded-[4px] m-[2px] mt-[1px] ml-[1px] p-3 bg-[#E5E4E2]", 
        index === props.phasePage?.phases.length - 1 ? 'h-full' : 'h-auto'
      ])
            }, [
              _createElementVNode("h4", _hoisted_12, _toDisplayString(phase?.phase), 1),
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_component_RouterLink, {
                  to: `/projects/${_unref(route).params.id}/phase/${phase.phaseId}`,
                  class: "w-full cursor-pointer h-fit"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_14, [
                      (selectedPhaseId.value === phase.phaseId)
                        ? (_openBlock(), _createElementBlock("img", _hoisted_15))
                        : (_openBlock(), _createElementBlock("img", _hoisted_16)),
                      _createElementVNode("h5", _hoisted_17, _toDisplayString(_unref(t)("global.review")), 1),
                      _createElementVNode("div", _hoisted_18, [
                        ([3, 4, 5].includes(phase.phaseStatus.id))
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 0,
                              class: "text-primary-text-color font-medium text-[13px] tracking-[0.01rem] px-[6px] py-[2px] rounded-primary-radius",
                              style: _normalizeStyle({
                  backgroundColor: `${_unref(getPhaseStatusColor)(
                    phase.phaseStatus.id
                  )}`,
                })
                            }, _toDisplayString(phase.phaseStatus.name), 5))
                          : (_openBlock(), _createBlock(ColoredDot, {
                              key: 1,
                              "status-name": phase.phaseStatus.name,
                              "status-id": phase.phaseStatus.id,
                              "is-termin": false
                            }, null, 8, ["status-name", "status-id"]))
                      ])
                    ]),
                    (selectedPhaseId.value === phase.phaseId)
                      ? (_openBlock(), _createElementBlock("ul", _hoisted_19, [
                          (props.isLoading)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                _createVNode(SpinnerLoader)
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.phasePage?.steps, (step) => {
                                  return (_openBlock(), _createElementBlock("li", {
                                    class: "w-full flex flex-col gap-2 py-[2px] relative before:absolute before:w-[2px] before:bg-[#D3D1CD] before:h-full before:-ml-[6px]",
                                    key: step.id
                                  }, [
                                    _createVNode(_component_RouterLink, {
                                      to: `/projects/${_unref(projectId)}/phase/${phase.phaseId}/#step-${step.id}`,
                                      class: _normalizeClass(["break-words w-full relative text-sm p-[6px] rounded-primary-radius bg-transparent text-primary-text-color font-medium tracking-[0.01rem] cursor-pointer hover:bg-[#D3D1CD] duration-300", `${
                    _unref(route).hash &&
                    (_unref(route).hash.replace('#step-', '') == step.id ||
                      _unref(route).hash.replace('#scroll-step-', '') == step.id)
                      ? 'bg-white before:absolute before:w-[2px] before:top-0 before:-left-[6px] before:bg-[#51687A] before:h-full'
                      : 'bg-transparent'
                  }`])
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(step.name), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["to", "class"])
                                  ]))
                                }), 128))
                              ]))
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1032, ["to"]),
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("div", {
                    onClick: ($event: any) => (toggleAppointmentsDropdown(phase)),
                    class: "w-full flex items-center gap-1 p-[6px] rounded-primary-radius hover:bg-[#D3D1CD] duration-300"
                  }, [
                    (selectedAppointment.value === phase)
                      ? (_openBlock(), _createElementBlock("img", _hoisted_24))
                      : (_openBlock(), _createElementBlock("img", _hoisted_25)),
                    _createElementVNode("h5", _hoisted_26, _toDisplayString(_unref(t)("global.termins")), 1)
                  ], 8, _hoisted_23),
                  (selectedAppointment.value === phase)
                    ? (_openBlock(), _createElementBlock("ul", _hoisted_27, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(phase.termins, (termin) => {
                          return (_openBlock(), _createElementBlock("li", {
                            class: "w-full flex flex-col gap-2 relative before:absolute before:w-[2px] before:bg-[#D3D1CD] before:h-full before:-ml-[6px]",
                            key: termin.id
                          }, [
                            _createVNode(_component_RouterLink, {
                              to: `/projects/${_unref(route).params.id}/termin/${termin.id}`,
                              class: "w-full flex items-center gap-[6px] text-sm p-[6px] rounded-primary-radius bg-transparent text-primary-text-color font-medium tracking-[0.01rem] cursor-pointer hover:bg-white duration-300"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("span", null, _toDisplayString(termin.end
                    ? new Date(termin.end).toLocaleDateString("DE")
                    : "Not scheduled"), 1),
                                _createVNode(ColoredDot, {
                                  "status-name": termin.termin_status.name,
                                  "status-id": termin.termin_status.id,
                                  "is-termin": true
                                }, null, 8, ["status-name", "status-id"])
                              ]),
                              _: 2
                            }, 1032, ["to"])
                          ]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ], 2))
          }), 128))
        ]))
      : (props.appointmentPage)
        ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.appointmentPage, (phase, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: phase.id,
                class: _normalizeClass(["w-full h-fit rounded-[4px] m-[2px] mt-[1px] ml-[1px] py-4 px-3 bg-[#E5E4E2]", index === props.appointmentPage?.length - 1 ? 'h-full' : 'h-auto'])
              }, [
                _createElementVNode("h4", _hoisted_29, [
                  _createTextVNode(_toDisplayString(phase?.phase.name) + " ", 1),
                  _cache[2] || (_cache[2] = _createElementVNode("span", null, null, -1))
                ]),
                _createElementVNode("div", _hoisted_30, [
                  _createVNode(_component_RouterLink, {
                    to: `/projects/${_unref(projectId)}/phase/${phase.phase.id}`,
                    class: "w-full cursor-pointer"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_31, [
                        _cache[3] || (_cache[3] = _createElementVNode("img", {
                          src: _imports_0,
                          alt: "Eye"
                        }, null, -1)),
                        _createElementVNode("h5", _hoisted_32, _toDisplayString(_unref(t)("global.review")), 1),
                        _createElementVNode("div", _hoisted_33, [
                          ([3, 4, 5].includes(phase.status.id))
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 0,
                                class: "text-primary-text-color font-medium text-[13px] tracking-[0.01rem] px-[6px] py-[2px] rounded-primary-radius",
                                style: _normalizeStyle({
                  backgroundColor: `${_unref(getPhaseStatusColor)(phase.status.id)}`,
                })
                              }, _toDisplayString(phase.status.name), 5))
                            : (_openBlock(), _createBlock(ColoredDot, {
                                key: 1,
                                "status-name": phase.status.name,
                                "status-id": phase.status.id,
                                "is-termin": false
                              }, null, 8, ["status-name", "status-id"]))
                        ])
                      ]),
                      _cache[4] || (_cache[4] = _createElementVNode("ul", null, null, -1))
                    ]),
                    _: 2
                  }, 1032, ["to"]),
                  _createElementVNode("div", _hoisted_34, [
                    _createElementVNode("div", {
                      class: "w-full flex items-center gap-1 p-[6px] rounded-primary-radius hover:bg-[#D3D1CD] duration-300",
                      onClick: ($event: any) => (toggleAppointmentsDropdown(phase.phase.id))
                    }, [
                      (appointmentsDropdownOpened.value.includes(phase.phase.id))
                        ? (_openBlock(), _createElementBlock("img", _hoisted_36))
                        : (_openBlock(), _createElementBlock("img", _hoisted_37)),
                      _createElementVNode("h5", _hoisted_38, _toDisplayString(_unref(t)("global.termins")), 1)
                    ], 8, _hoisted_35),
                    (appointmentsDropdownOpened.value.includes(phase.phase.id))
                      ? (_openBlock(), _createElementBlock("ul", _hoisted_39, [
                          (props.isLoading)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                                _createVNode(SpinnerLoader)
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_41, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(phase.termins, (termin) => {
                                  return (_openBlock(), _createElementBlock("li", {
                                    class: "w-full flex flex-col gap-2 py-[2px] relative before:absolute before:w-[2px] before:bg-[#D3D1CD] before:h-full before:-ml-[6px]",
                                    key: termin.id
                                  }, [
                                    _createVNode(_component_RouterLink, {
                                      to: `/projects/${_unref(route).params.id}/termin/${termin.id}`,
                                      class: _normalizeClass(["w-full flex items-center gap-[6px] text-sm p-[6px] rounded-primary-radius bg-transparent text-primary-text-color font-medium tracking-[0.01rem] cursor-pointer hover:bg-[#D3D1CD] duration-300", 
                    _unref(route).params.terminId === termin.id
                      ? 'bg-white before:absolute before:w-[2px] before:top-0 before:left-[-6px] before:bg-[#51687A] before:h-full'
                      : 'bg-transparent'
                  ])
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("span", null, _toDisplayString(termin.end
                      ? new Date(termin.end).toLocaleDateString("DE")
                      : "Not scheduled"), 1),
                                        _createVNode(ColoredDot, {
                                          "status-name": termin.status.name,
                                          "status-id": termin.status.id,
                                          "is-termin": true
                                        }, null, 8, ["status-name", "status-id"])
                                      ]),
                                      _: 2
                                    }, 1032, ["to", "class"])
                                  ]))
                                }), 128))
                              ]))
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ], 2))
            }), 128))
          ]))
        : _createCommentVNode("", true)
}
}

})